import React from "react";
import { useFormInput } from "./form";
import { get, set } from "./localStorage";

export const LOGIN_URL_KEY = "REACT_APP_CATADMIN_URL";

export let urls = [
	["Live", "https://catalogueapi-admin.configura.com"],
	["Test", "https://catalogueapi-admin-test.configuracloud.com"],
	["Dev", "https://catalogueapi-admin-dev.configuracloud.com"],
	["Dev2", "https://catalogueapi-admin-dev2.configuracloud.com"],
	["QA", "https://catalogueapi-admin-qa.configuracloud.com"],
	["ISKU", "https://catalogueapi-admin-isku.configuracloud.com"],
	["Local", "http://127.0.0.1:4285"],
];

export function useLoginUrlFormInput() {
	const url = useFormInput(
		"url",
		get(LOGIN_URL_KEY) || process.env.REACT_APP_CATADMIN_URL || urls[3][1]
	);

	const handleChange = (
		e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
	) => {
		set(LOGIN_URL_KEY, e.currentTarget.value);
		url.onChange(e);
	};

	return { ...url, onChange: handleChange, values: urls };
}
